import React, { useState } from "react";
import DisclamerModal from "../../components/modals/DisclamerModal";



export default function Landing({ nextStep, changeVal, values, logo, partner, disclamer, disclamerTxt, disclamerTitle, landingColor }) {
    return (
        <div>
            <div className="bg-white-900 dark:bg-white-900">
                <div className="grid px-8 py-8 my-10 mx-auto w-fit py-0 justify-center h-screen content-center">

                    <div className="flex text-center justify-center mb-4 text-4xl font-bold text-black">
                        <img className="h-20" src={logo} />
                    </div>

                    <div className="bg-white rounded-lg shadow dark:border width-screen xl:p-0 ">
                        <div className="p-6 space-y-1 sm:p-8">
                            <div className="text-4xl text-black font-bold text-center leading-tight tracking-tight">
                                Let's start your merchant application!
                            </div>
                            <div className="text-center">
                                {disclamer ? (
                                    <div className="-mt-2">
                                        <DisclamerModal title = {disclamerTitle} desc = {disclamerTxt} color = {landingColor} partner = {partner} nextStep={nextStep}></DisclamerModal>
                                    </div>
                                ) : (
                                    <button onClick={nextStep} style = {{backgroundColor: landingColor}} className= {`text-white mt-6 inline-block w-1/2 focus:ring-4 font-medium rounded-lg text-sm px-5 py-2.5 focus:outline-none`} >
                                        Get started!
                                    </button>
                                )}
                                
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>




    );
}